import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    products: [],
  },
  getters: {
    products(state) {
      return state.products;
    },
  },
  mutations: {
    setProducts(state, payload) {
      state.products = payload;
    },
  },
  actions: {
    getProducts({ commit }) {
      axios
        .get(
          'https://api.cosmicjs.com/v1/dengo-e-arte/objects?pretty=true&hide_metafields=true&type=produtos&read_key=osVDatZZadkO5IvGEqcHgK3F9q9JDw2CwlePrkj2OUluYguxTV&limit=20&props=title,content,metadata&sort="created_at"'
        )
        .then((res) => commit('setProducts', res.data.objects))
        .catch((err) => console.log(err));
    },
  },
});
